import { createContext, useContext } from 'react';

import { FinancialOverviewSectionDragControl } from '../../types';

export const FinancialOverviewSectionDragContext = createContext<FinancialOverviewSectionDragControl | undefined>(
    undefined,
);

export const useFinancialOverviewSectionDrag = () => useContext(FinancialOverviewSectionDragContext);
